import React from 'react';
import ParticipantStrip from '../ParticipantStrip/ParticipantStrip';
import { styled } from '@material-ui/core/styles';
import MainParticipant from '../MainParticipant/MainParticipant';
import './Room.css';
import useLocalAudioToggle from '../../hooks/useLocalAudioToggle/useLocalAudioToggle';
import useLocalVideoToggle from '../../hooks/useLocalVideoToggle/useLocalVideoToggle';
import useFullScreenToggle from '../../hooks/useFullScreenToggle/useFullScreenToggle';

const Container = styled('div')(({ theme }) => ({
  position: 'relative',
  height: '100%',
  display: 'grid',
  gridTemplateColumns: `${theme.sidebarWidth}px 1fr`,
  gridTemplateAreas: '". participantList"',
  gridTemplateRows: '100%',
  [theme.breakpoints.down('xs')]: {
    gridTemplateAreas: '"participantList" "."',
    gridTemplateColumns: `auto`,
    gridTemplateRows: `calc(100% - ${theme.sidebarMobileHeight + 12}px) ${theme.sidebarMobileHeight + 6}px`,
    gridGap: '6px',
  },
}));

const FullScreenContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  height: '100%',
  width: '100%',
}));

export default function Room() {
  const [isAudioEnabled] = useLocalAudioToggle();
  const [isVideoEnabled] = useLocalVideoToggle();
  const [isFullScreen] = useFullScreenToggle();

  localStorage.setItem('zuperConnect_AudioPreference', JSON.stringify(isAudioEnabled ? 'On' : 'Off'));
  localStorage.setItem('zuperConnect_VideoPreference', JSON.stringify(isVideoEnabled ? 'On' : 'Off'));

  return !isFullScreen ? (
    <Container>
      <ParticipantStrip />
      <MainParticipant />
    </Container>
  ) : (
    <FullScreenContainer>
      <MainParticipant />
    </FullScreenContainer>
  );
}
